<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title=" Ternakan">
		  <z-table title="Senarai" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #button v-if="$zutil.role('Al Man')">
              <w-button dark class="green--bg ml1"  @click="add()">
                  <w-icon class="mr1">fal fa-plus</w-icon> Cari Ternakan
              </w-button>
          </template>
		    <template #header-label="{ header, label, index }">
		      <template v-if="header.key == 'action'">
			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
            Tindakan
          </template>
		      <template v-else>
		      	{{ label }}
		      </template>
		    </template>
		    <template #item-cell.action="{ item, label, header, index }">
		      <w-flex class="flex justify-center">
		        <inertia-link :href="$route('ternakan.show',item.ternakan_id)+'?insemination=1'" class="w-button w-button--dark size--md info-dark1--bg"> 
              <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
            </inertia-link>
		      </w-flex>
		    </template>
		  </z-table>
	  </z-page>
    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
        <w-icon class="mr2">fal fa-cog</w-icon>
        Carian Ternakan
      </template>
      <w-flex justify-center align-center>
        <div class="xs11">
          <w-input label="Carian" placeholder="Kode Teranakan, Nama Ternakan, Nama Peternak, NRIC Peternak" type="text" v-model="form.q" />
        </div>
        <div class="xs1">
          <w-button dark class="green--bg ml1"  @click="cari()">
            <w-icon class="mr1">fal fa-search</w-icon> Cari 
          </w-button>
        </div>
      </w-flex>
      
      <div class="w-table-wrap" style="max-height: 400px;">
        <table class="w-table" color="light" >
          <thead>
            <tr>
              <th class="w-table__header  text-left" width="1%">No</th>
              <th class="w-table__header  text-left">Ternakan</th>
              <th class="w-table__header  text-left">Baka</th>
              <th class="w-table__header  text-left">Generasi</th>
              <th class="w-table__header  text-left">Kode</th>
              <th class="w-table__header  text-left">Nama</th>
              <th class="w-table__header  text-left">Pemilik</th>
              <th class="w-table__header  text-left">Tindakan</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="ternakan.length == 0">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
              </tr>
            </template>
            <template v-for="(dt, ind) in ternakan">
              <tr class="w-table__row" >
                <td class="w-table__cell text-left" >{{ind+1}}</td>
                <td class="w-table__cell text-left" >{{dt.lkp_ternakan}}</td>
                <td class="w-table__cell text-left" >{{dt.lkp_baka}}</td>
                <td class="w-table__cell text-left" >{{dt.lkp_gred}}</td>
                <td class="w-table__cell text-left" >{{dt.kode}}</td>
                <td class="w-table__cell text-left" >{{dt.nama}}</td>
                <td class="w-table__cell text-left" >{{dt.user}}</td>
                <td class="w-table__cell text-left" >
                  <inertia-link :href="$route('ternakan.show',dt.id)+'?insemination=1'" class="w-button black  info-dark1--bg size--md be fs-2"> 
                    <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
                  </inertia-link>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <template #actions>
        <div class="spacer" />
        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      </template>
    </w-dialog>
  </zen-one>
  
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'insemination.stok',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Inseminasi Ternakan', route: '/insemination/ternakan' },
      ],
      form :{
        q : ''
      },
      ternakan : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      
    }
  },
  methods: {
    
    add(){
      this.form = {
        q : ''
      }
      this.ternakan = [],
      this.dialog.show = true
    },
    cari(){
      this.$zcomm.get(this.api_service + 'ternakan/betina', this.form).then(res => {
        this.ternakan = res
      })
    }
    
  
  },

  watch: {

  },
  mounted() {
    
    
      
  },
}
</script>
